/*
  globals document, window
*/
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';

import configureStore from './configureStore';

import App from './App';

const history = createHistory();
const { store } = configureStore(history, window.REDUX_STATE);


render(
  <Provider store={store}>
    <App />
  </Provider>, document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js